import React, { useState, useEffect } from "react";
import { Alert, AlertTitle, IconButton, Modal, Snackbar, TextField } from "@mui/material";
import axios from "axios";
import housestyles from "./../Hostels/houses.module.css";
import housestyle from "./../Landlords/style.module.css";
import accountstyle from "./../Account/style.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loadingspinner from "../Components/loading";
import { Fetchmysinglebizurl, FetchSinglebizurl, Updatemybizurl } from "../Utils/urls";
import { isDesktop, isMobile } from "react-device-detect";
import Universalheader from "../Headers/universalheader";
import SignIn from "../Common/login";
import Sharepopup from "../Components/sharepopup";
import { FaEdit, FaFacebookMessenger, FaPhoneAlt, FaSave, FaShareSquare, FaStarOfLife } from "react-icons/fa";
import { primarycolor } from "../Utils/colors";
import MapComponent from "../Hostels/mapcomponent";
import { getsessionuser, setsessionhouse } from "../Utils/sessions";
import Shuffle from "../Utils/shuffle";
import { Add, AddCircle, AddRounded, Delete, PlusOneOutlined } from "@mui/icons-material";

const Viewmysinglebiz = ({ onrefresh }) => {
    const user = getsessionuser();
    const location = useLocation();
    const navigate = useNavigate();
    const id = location.pathname.split("/")[3];

    const [showbutton, setshowbutton] = useState(true);
    const [itemimage, setitemimage] = useState('');
    const [name, setname] = useState('');

    //basics
    const [loading, setloading] = useState(true);
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');
    const [edit, setedit] = useState(false);
    const [nothing, setnothing] = useState(false);
    //shows
    const [showloginpopup, setshowloginpopup] = useState(false);
    const [sharepopup, setsharepopup] = useState(false);
    const [showimage, setshowimage] = useState(false);

    //objects
    const [defaulturl, setdefaulturl] = useState('');

    //arrays
    const [business, setbusiness] = useState('');
    const [catalogue, setcatalogue] = useState([]);

    const [slot1, setSlot1] = useState('');
    const [bname, setBname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [description, setDescription] = useState('');

    const [error14, seterror14] = useState('');

    const [itemname, setitemname] = useState('');
    const [itemdescription, setitemdescription] = useState('');
    const [itemprice, setitemprice] = useState('');




    useEffect(() => {
        fetchbusiness()
    }, []);

    const fetchbusiness = () => {
        setloading(true)
        axios.post(Fetchmysinglebizurl, {
            id: id
        }).then(function (response) {
            setloading(false)
            if (!response.data.message) {
                setbusiness(response.data[0])
                setBname(response.data[0].bname)
                setEmail(response.data[0].email)
                setDescription(response.data[0].description)
                setPhone(response.data[0].phone)
                setcatalogue(Shuffle(response.data[0]?.subcategory))
            } else {
                seterror(response.data.message);
            }
            // 
        }).catch(function (error) {
            console.log(error)
            setloading(false)
            seterror("Sorry there was an error try again later")
            //if(error.response.status === 401 || error.response.status === 400){}

        });
    }


    //add items to catalogue stac
    const addtostack = () => {
        seterror14(null)

        if (!itemname | !itemdescription | !itemprice) {
            seterror14("fill catalogue fields")
        } else {
            const myObj = { name: itemname, description: itemdescription, price: itemprice, email: user.email };
            //  const myJSON = JSON.stringify(myObj);
            catalogue.push(myObj)
            setitemname('')
            setitemprice("")
            setitemdescription("")
        }
    }

    //save business
    const Onsave = () => {
        if (!phone | !bname | !email | !description) {
            seterror("Fill all fields")
        } else {
            seterror(null)
            setloading(true)
            axios.post(Updatemybizurl + '?5$fgk=hh', {
                bname: bname,
                phone: phone,
                email: email,
                description: description,
                catalogue: catalogue,
                id: id
            }).then(response => {
                setloading(false)
                if (!response.data.message) {
                    if (response.data.success) {
                        setedit(false)
                        setsuccess(response.data.success);
                        fetchbusiness()
                        setedit(false)

                    } else {
                        seterror("There was an internal error.Contact admin");
                    }

                } else {
                    seterror(response.data.message)
                }
                // 
            }).catch(error => {
                setloading(false)
                seterror("Sorry an error occurred,try again later");
                //if(error.response.status === 401 || error.response.status === 400){}

            });
        }
    }

    //update slot images
    //updating slots photos
    const onSlot1 = () => {
        if (!slot1) {
            seterror("Select an image to upload")
        } else {
            setloading(true)
            seterror(null)
            // Create an object of formData
            const formData = new FormData();
            formData.append(
                "file",
                slot1,
                slot1.name
            );
            axios.post("https://eazistey.co.ke/API_WEB_HOOKS/update_servicephotos_api.php?5$fgk=hh&id=" + id + "&slot=slot1", formData).
                then(response => {
                    if (!response.data.message) {
                        setloading(false)
                        setsuccess(response.data.success)
                        setedit(false)
                        fetchbusiness()
                    } else {
                        setloading(false)
                        seterror(response.data.message)
                    }
                    // 
                }).catch(error => {
                    seterror("Sorry an error occurred,try again later");
                    setloading(false)
                    //if(error.response.status === 401 || error.response.status === 400){}

                });
        }
    }


    const url = 'https://eazistey.co.ke/nav/viewsinglebusiness/' + id

    //start chat
    const startchat = () => {
        setsessionhouse(business)
        user ? navigate('/nav/chats', {
            state: {
                message: "startchart"
            }
        }) : setshowloginpopup(true)

    }

    //redirect user after success login
    const onsuccesslogin = () => {
        onrefresh()
        navigate('/nav/chats', {
            state: {
                message: "startchart"
            }
        })
    }




    return (
        <div>
            {loading && <Loadingspinner />}
            <Snackbar open={error?.length > 0 && true} autoHideDuration={3000} onClose={() => seterror()}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
            <Snackbar open={success?.length > 0 && true} autoHideDuration={3000} onClose={() => setsuccess()}>
                <Alert severity="success">{success}</Alert>
            </Snackbar>
            <div>
                <main className={housestyles.parent}>
                    <Modal
                        open={showloginpopup}
                        onClose={() => setshowloginpopup(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <SignIn onsuccesslogin={onsuccesslogin} />
                    </Modal>
                    <div className={housestyles.container}>
                        <Modal
                            open={sharepopup}
                            onClose={() => setsharepopup(false)}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Sharepopup name={"Share Business link through"} link={url} />
                        </Modal>
                        <Modal
                            open={showimage}
                            onClose={() => setshowimage(false)}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <div>
                                <img src={defaulturl} style={{ width: isMobile ? "100%" : isDesktop ? 800 : 500, margin: "0 auto", height: isMobile ? 400 : isDesktop ? 600 : 500 }} />
                            </div>
                        </Modal>
                        <div className={housestyles.topheader} style={{ paddingBottom: 20 }}>
                            <Universalheader />
                            <div className={housestyles.advertisediv}>
                                <FaStarOfLife color={primarycolor} size={15} />
                                <Link to="">
                                    <a href="https://play.google.com/store/apps/details?id=com.eazistey.eazistey">List on Eazistey</a>
                                </Link>
                            </div>
                            <div className={housestyles.housenamediv}>
                                {/* <div onClick={() => setsharepopup(true)} style={{ position: "absolute", right: "6%", cursor: "pointer", fontSize: 12 }}>
                                    <FaShareSquare /><u>Share</u>
                                </div> */}
                                {edit ? <div className={housestyle.editbutton} onClick={Onsave}>
                                    <FaSave size={20} />
                                </div> : <div className={housestyle.editbutton} onClick={() => setedit(!edit)}>
                                    <FaEdit size={20} />
                                </div>}
                                <div className={housestyles.housenamehead}>{business.bname?.toUpperCase()}</div>

                            </div>
                            <div className={housestyles.linksdiv}>
                                <Link to="/nav">
                                    <a>Home  /</a>
                                </Link>
                                <a onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>Services  /</a>
                                <a>{business.bname}  /</a>
                            </div>
                            <div className={housestyles.bodydiv}>
                                <div></div>
                                <div className={housestyles.housedetailsdiv}>
                                    <div className="businesswrapflex">
                                        <div className="businessfirstdiv">
                                            <img src={business.url1} className="businessimage" /><br />
                                            {edit &&
                                                <div>
                                                    <input type="file" onChange={e => setSlot1(e.target.files[0])} />
                                                    <button onClick={onSlot1}>
                                                        Upload!
                                                    </button>
                                                    <br /> <br />
                                                </div>}
                                            {!edit && <div className="businessdesc">{business?.description}</div>}
                                            {edit && <div>
                                                <div className={accountstyle.inputdiv}>
                                                    Business name<br />
                                                    <input name="bname" value={bname} onChange={(e) => setBname(e.target.value)} />
                                                </div>
                                                <div className={accountstyle.inputdiv}>
                                                    Business phone<br />
                                                    <input name="phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
                                                </div>
                                                <TextField
                                                    id="outlined-basic"
                                                    sx={{ maxHeight: 20, marginBottom: 2, width: "80%" }}
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    FormHelperTextProps={{ fontSize: 10 }}
                                                    inputProps={{ fontSize: 10 }}
                                                    type={"tel"}
                                                    variant="outlined" size="small" /><br />
                                            </div>
                                            }
                                            <br />
                                            <div className="businessdesc"><b>{business?.service}</b></div>
                                            <br />
                                            {edit && <div>
                                                <hint htmlFor="subject" className=""><b>Add item</b></hint>
                                                <br />
                                                Name:<br />
                                                <input type="text" className="inputs12" placeholder="*printing*" value={itemname} onChange={e => setitemname(e.target.value)} /><br />
                                                Description:<br /><input type="text" className="inputs12" placeholder="*1 page*" value={itemdescription} onChange={e => setitemdescription(e.target.value)} /><br />
                                                Price:<br /> <input type="number" className="inputs12" placeholder="*sh 10* " value={itemprice} onChange={e => setitemprice(e.target.value)} /><br />
                                                <text style={{ color: "red" }}>{error14}</text><br />
                                                <IconButton size="small" aria-label="add" title="delete" onClick={addtostack}>
                                                    <AddCircle color="error" />
                                                </IconButton>
                                            </div>}
                                        </div>
                                        <div className="businessseconddiv">
                                            <b>Catalogue</b>
                                            <div className="wrapbusinesscatalogue">
                                                {catalogue?.map((val, key) => {
                                                    const removeitem = () => {
                                                        var index = catalogue.findIndex(obj => obj?.name == val.name);
                                                        delete catalogue[index];
                                                        const results = catalogue.filter(element => {
                                                            return element !== null;
                                                        });
                                                        setcatalogue(results)
                                                        setnothing(!nothing)
                                                    }
                                                    //upload item image
                                                    const onupload = () => {
                                                        setedit(false)
                                                        var index = catalogue.findIndex(obj => obj?.name == val.name);
                                                        delete catalogue[index];


                                                        const formData = new FormData();
                                                        formData.append(
                                                            "file",
                                                            itemimage,
                                                            itemimage.name
                                                        );

                                                        if (itemimage.name) {
                                                            setloading(true)
                                                            //upload item image
                                                            axios.post("https://eazistey.co.ke/API_WEB_HOOKS/Hotels/upload_itemimage_api.php?5$fgk=hh", formData).
                                                                then(response => {
                                                                    if (!response.data.message) {
                                                                        const myObj = { name: itemname, description: itemdescription, price: itemprice, url: 'https://eazistey.co.ke/API_WEB_HOOKS/images/' + itemimage.name, email: email };
                                                                        catalogue.push(myObj)

                                                                        const results = catalogue.filter(element => {
                                                                            return element !== null;
                                                                        });
                                                                        //update item details
                                                                        axios.post("https://eazistey.co.ke/API_WEB_HOOKS/Services/update_itemdetails_api.php?5$fgk=hh", {
                                                                            menu: results,
                                                                            id: id
                                                                        }).
                                                                            then(response => {
                                                                                if (!response.data.message) {
                                                                                    setloading(false)
                                                                                    setsuccess(response.data.success)
                                                                                    setedit(false)
                                                                                    fetchbusiness()

                                                                                } else {
                                                                                    setloading(false)
                                                                                    seterror(response.data.message)
                                                                                }
                                                                                // 
                                                                            }).catch(error => {
                                                                                seterror("Sorry an error occurred,try again later");
                                                                                setloading(false)
                                                                                //if(error.response.status === 401 || error.response.status === 400){}
                                                                            });
                                                                    } else {
                                                                        setloading(false)
                                                                        seterror(response.data.message)
                                                                    }
                                                                    // 
                                                                }).catch(error => {
                                                                    seterror("Sorry an error occurred,try again later");
                                                                    setloading(false)
                                                                    //if(error.response.status === 401 || error.response.status === 400){}

                                                                });
                                                        }

                                                    }
                                                    return (
                                                        <div className="catalogueitemchild" key={key} >
                                                            {edit &&
                                                                <IconButton size="small" aria-label="delete" title="delete" onClick={removeitem}>
                                                                    <Delete color="error" />
                                                                </IconButton>
                                                            }
                                                            <img src={val?.url ? val.url : require("./../../assets/common/image2.png")} />
                                                            <div>
                                                                <b>{val?.name}</b><br />
                                                                {val?.description.substring(0, 20)}<br />
                                                                <b>{val?.price}</b> Ksh<br />
                                                            </div>
                                                            {edit && <div> {showbutton ? <button style={{
                                                                border: "none", marginTop: 5,
                                                                padding: 3, color: "white",
                                                                backgroundColor: "rgb(230, 52, 52)",
                                                                borderRadius: 5
                                                            }}
                                                                onClick={() => {
                                                                    setname(val.name);
                                                                    setshowbutton(false)
                                                                    setitemname(val.name)
                                                                    setitemdescription(val.description)
                                                                    setitemprice(val.price)
                                                                }}>Attach image</button> :
                                                                name === val.name && <div>
                                                                    <div style={{ width: 70 }}><input type="file" onChange={e => setitemimage(e.target.files[0])} /></div>
                                                                    <button onClick={onupload} style={{ border: "none", marginTop: 5, padding: 3, color: "white", backgroundColor: "rgb(230, 52, 52)", borderRadius: 5 }}>
                                                                        Upload!
                                                                    </button>
                                                                </div>
                                                            }
                                                            </div>}

                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {isDesktop && business.type !== "remote" &&
                                <div className={housestyles.singelhousemap}>
                                    <div style={{ display: "flex" }}>
                                        <div className={housestyles.whereyou}>Where the business is</div>
                                        <a style={{ marginTop: 5, marginLeft: 20 }} href={`https://maps.eazistey.co.ke/?longitude=${catalogue[0]?.longitude}&latitude=${catalogue[0]?.latitude}`}>View directions</a>
                                    </div>
                                    <br /><br />
                                    {catalogue[0]?.longitude && <MapComponent longitude={catalogue[0]?.longitude} latitude={catalogue[0]?.latitude} />}
                                    <div style={{ fontWeight: "bold", marginTop: 10 }}>
                                        {catalogue[0]?.location},Chuka, Kenya
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </main>
            </div>

        </div>

    )
}

export default Viewmysinglebiz;